import React from "react";
import { useState, useEffect, useRef } from "react";
import Dropdown from './Dropdown';
import { Link } from 'react-router-dom';


function MenuItems({ items, depthLevel, autenticazione, temaColori }) {

    let permessiRichiesti;
    let permessiUtente;

    if (items.permessi) {
        permessiRichiesti = items.permessi;
    }

    if (autenticazione && autenticazione.permessiAPI) {
        permessiUtente = autenticazione.permessiAPI;
    }


    let permesso = false;

    if (!permessiRichiesti) {
        permesso = true;
    }  else if (permessiUtente && (Array.isArray(permessiRichiesti) ? permessiRichiesti.some(p => permessiUtente[p]) : permessiUtente[permessiRichiesti])) {
        permesso = true;

    } else {
        /* console.log("non hai il permesso per "+items.title+", permesso richiesto: "+permessiRichiesti) */
    }

    const [dropdown, setDropdown] = useState(false);
    let ref = useRef();
    useEffect(() => {
        const handler = (event) => {
            if (dropdown && ref.current && !ref.current.contains(event.target)) {
                setDropdown(false);
            }
        };
        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, [dropdown]);

    const onMouseEnter = () => {
        window.innerWidth > 960 && setDropdown(true);
    };

    const onMouseLeave = () => {
        window.innerWidth > 960 && setDropdown(false);
    };

    const closeDropdown = () => {
        dropdown && setDropdown(false);
      };

    return (
        <li
            className="menu-items"
            ref={ref}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={closeDropdown}
        >
            {items.url && items.submenu && permesso ? (
                <>
                    <button
                        type="button"
                        aria-haspopup="menu"
                        aria-expanded={dropdown ? 'true' : 'false'}
                        onClick={() => setDropdown((prev) => !prev)}
                    >
                        {window.innerWidth < 960 && depthLevel === 0 ? (
                            items.title
                        ) : (
                            <Link to={items.url}>{items.title}</Link>
                        )}

                        {depthLevel > 0 &&
                            window.innerWidth < 960 ? null : depthLevel > 0 &&
                                window.innerWidth > 960 ? (
                            <span>&raquo;</span>
                        ) : (
                            <span className="arrowMenu" />
                        )}
                    </button>
                    <Dropdown
                        depthLevel={depthLevel}
                        submenus={items.submenu}
                        dropdown={dropdown}
                        autenticazione={autenticazione}
                    />
                </>
            ) : !items.url && items.submenu && permesso ? (
                <>
                    <button
                        type="button"
                        aria-haspopup="menu"
                        aria-expanded={dropdown ? 'true' : 'false'}
                        onClick={() => setDropdown((prev) => !prev)}
                    >
                        {items.title}{' '}
                        {depthLevel > 0 ? (
                            <span>&raquo;</span>
                        ) : (
                            <span className="arrowMenu" />
                        )}
                    </button>
                    <Dropdown
                        depthLevel={depthLevel}
                        submenus={items.submenu}
                        dropdown={dropdown}
                    />
                </>
            ) : permesso ? (
                <Link to={items.url}>{items.title}</Link>
            ) : (
                <p className="gray menu-items">{items.title}</p>
            )
        }
        </li>
    );
}

export default MenuItems;